import type { Message } from '../../../../contexts/ConversationContext';
import type { ReplayStep } from '../../../../contexts/ReplayContext';
import { messagesToDag } from './messagesToDag';
import { EMPTY_RUNTIME } from './runtimeOverlay';

/** TH-3c — derive replay steps by running the processor as the clustering ORACLE:
 * one step per assistant message THAT RENDERS A NODE, keyed on the node's real turnKey
 * (handles all 3 turnKey conventions + greet-orphan anchors). endIndex slices the ORIGINAL
 * array → prefix-closed by construction. Pure (calls the pure processor). */
export function buildReplaySteps(messages: Message[]): ReplayStep[] {
  const { nodes } = messagesToDag(messages as any, EMPTY_RUNTIME as any);
  const msgIdToTurnKey = new Map<string, string>();
  for (const n of nodes) {
    const d = n.data as any;
    if (d?.messageId != null && d?.turnKey != null) msgIdToTurnKey.set(d.messageId, d.turnKey);
    if (d?.spineRootMessageId != null && d?.turnKey != null) msgIdToTurnKey.set(d.spineRootMessageId, d.turnKey);
  }
  const steps: ReplayStep[] = [];
  messages.forEach((m, i) => {
    if (m.role !== 'assistant') return;
    const anchor = msgIdToTurnKey.get(m.id);
    if (anchor == null) return;   // plan-triad S2: node-less assistant (suppressed/deduped) → skip, no dead step
    steps.push({ anchor, endIndex: i });
  });
  return steps;
}

export function messagesUpToStep(messages: Message[], steps: ReplayStep[], k: number): Message[] {
  if (steps.length === 0) return messages;
  const idx = Math.max(0, Math.min(k, steps.length - 1));
  return messages.slice(0, steps[idx].endIndex + 1);
}
